import { BO, BusinessObjectBase, NonUniqueModelDataError, RepositoryResponseConflictCodes, ResponseConflictObject, Weaver } from '@skylab-shared/core';
import { ExpenseModel } from '@skylab-shared/dataModel';
import { sameValues } from '@skylab-shared/utils';

@BO({ modelType: ExpenseModel })
export class ExpenseBO extends BusinessObjectBase<ExpenseModel> {
    public constructor(
        weaver: Weaver,
    ) {
        super(weaver);
    }

    protected override handleConflictSaveResponse(conflict: ResponseConflictObject<RepositoryResponseConflictCodes>) {
        if ((conflict.code === RepositoryResponseConflictCodes.UniqueConstraintViolation) && sameValues(conflict.objectProperties!, ['name'])) {
            this.addExternalRuleViolations({
                [this.model.sun]: [{
                    property: 'name',
                    violation: new NonUniqueModelDataError('business.expense.validation.name.server-rule-violations.non-unique-model-data-error')
                }]
            });
        }
    }
}
